export default userAbbrFilter;

function userAbbrFilter() {
  return function (username) {
    return `${(username || '').trim()[0]}.`;
  };
}
